/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalisationDtoEnrichi } from '../../models/localisation-dto-enrichi';

export interface GetLocalisationById$Params {
  /**
   * id de la localisation
   */
  idLocalisation: string;
}

export function getLocalisationById(
  http: HttpClient,
  rootUrl: string,
  params: GetLocalisationById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<LocalisationDtoEnrichi>> {
  const rb = new RequestBuilder(rootUrl, getLocalisationById.PATH, 'get');
  if (params) {
    rb.path('idLocalisation', params.idLocalisation, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocalisationDtoEnrichi>;
    })
  );
}

getLocalisationById.PATH = '/v1/localisations/{idLocalisation}';
